import React from 'react';
import { Flame } from 'lucide-react';

interface StreakBadgeProps {
  count: number;
  isDark: boolean;
  className?: string;
}

export const StreakBadge: React.FC<StreakBadgeProps> = ({ count, isDark, className = "" }) => {
  if (count === 0) return null;

  return (
    <div 
      className={`flex items-center space-x-1.5 px-3 py-1.5 rounded-full border transition-all duration-300 hover:scale-105 ${
        isDark 
          ? 'bg-orange-500/10 border-orange-500/30 text-orange-400 shadow-lg shadow-orange-500/10' 
          : 'bg-orange-50/80 border-orange-200 text-orange-600 shadow-sm'
      } ${className}`}
      title={`${count} day learning streak!`}
    >
      <Flame className={`w-4 h-4 ${count > 5 ? 'animate-bounce' : ''} fill-current`} />
      <span className="text-sm font-bold tracking-tight">{count}</span>
    </div>
  );
};
